import axios from '@/utils/http';

export default params => {
  return axios
    .post('/advertisement_notice', params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
